import { createLayerCanvas, drawPointsPath, drawCircle, toDataUrl } from './canvasUtils'
import { extractLandmarkFeatures } from './extractLandmarkFeatures'

export const buildIrisLayer = ({ landmarks, width, height, features = null }) => {
  if (!landmarks?.length) return null
  const featureMap = features || extractLandmarkFeatures({ landmarks, width, height })
  const leftIrisRing = featureMap?.irises?.left?.ring || []
  const rightIrisRing = featureMap?.irises?.right?.ring || []
  const leftCenter = featureMap?.irises?.left?.center
  const rightCenter = featureMap?.irises?.right?.center
  if (!leftIrisRing.length && !rightIrisRing.length && !leftCenter && !rightCenter) return null
  const { canvas, ctx } = createLayerCanvas(width, height)
  if (leftIrisRing.length) {
    drawPointsPath(ctx, leftIrisRing, {
      close: true,
      fill: 'rgba(250, 204, 21, 0.8)'
    })
  }
  if (rightIrisRing.length) {
    drawPointsPath(ctx, rightIrisRing, {
      close: true,
      fill: 'rgba(250, 204, 21, 0.8)'
    })
  }
  if (leftCenter) {
    drawCircle(ctx, leftCenter.x, leftCenter.y, 2.2, 'rgba(202, 138, 4, 0.9)')
  }
  if (rightCenter) {
    drawCircle(ctx, rightCenter.x, rightCenter.y, 2.2, 'rgba(202, 138, 4, 0.9)')
  }
  return toDataUrl(canvas)
}
